//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'introduction',
  props: {
    logoUrl: {
      type: String,
      default: '@/assets/share/share.png'
    },
    pageTitle: {
      type: String,
      default: ''
    },
    intro: {
      type: String,
      default: ''
    },
    updatetime: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    content: {
      type: String,
      default: ''
    },
    detail: {
      type: String,
      default: ''
    },
    videoUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      videoDialogVisible: false
    };
  },
  methods: {
    openVideo: function openVideo() {
      this.videoUrl ? this.videoDialogVisible = true : this.$message('暂无更多介绍');
    },
    closeVideoDialog: function closeVideoDialog() {
      var play = document.getElementById('playVideo');
      play.pause();
    }
  }
};